'use client';
import { useState, useRef } from 'react';
import { useIsomorphicEffect } from '@s7/hooks';

const computeOffset = (labelHeight, controlHeight)=>{
    const maxControlsInContainer = Math.floor(labelHeight / controlHeight);
    const verticalFreeSpace = labelHeight - maxControlsInContainer * controlHeight;
    const gapBetweenImaginaryControls = verticalFreeSpace / maxControlsInContainer;
    return gapBetweenImaginaryControls / 2;
};
const useAdaptiveOffset = (deps)=>{
    const [offset, setOffset] = useState(0);
    const labelRef = useRef(null);
    const controlRef = useRef(null);
    useIsomorphicEffect(()=>{
        var _labelRef_current, _controlRef_current;
        const labelHeight = (_labelRef_current = labelRef.current) == null ? void 0 : _labelRef_current.clientHeight;
        const controlWrapperHeight = (_controlRef_current = controlRef.current) == null ? void 0 : _controlRef_current.clientHeight;
        const offsetPx = computeOffset(labelHeight, controlWrapperHeight);
        setOffset(offsetPx);
    }, deps);
    return {
        labelRef,
        controlRef,
        offset
    };
};

export { useAdaptiveOffset };
//# sourceMappingURL=useAdaptiveOffset.js.map
